module.exports = __webpack_public_path__ + "static/media/noun-cocktail-4419183-808080.19b962c2.svg";